var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconLeftButtonArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 36 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m7.4 15.1 1.4-1.4-4-3.9-.9-.6.1-.3 1.1.1h30.8V7H5.1L4 7.2l-.1-.3.9-.6 3.9-3.9L7.4 1 1 7.4v1.4z",
  className: "icon-left-button-arrow_svg__st0"
})));
export default SvgIconLeftButtonArrow;